var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0V0z","fill":"none","key":0}),React.createElement("path",{"d":"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z","key":1})]);
}

Trash.defaultProps = {"viewBox":"0 0 24 24","fill":"white","width":"100%","height":"100%"};

module.exports = Trash;

Trash.default = Trash;
